import React from 'react';
import { getScoreDisplayValue, getScorePosition } from '../../../pages/cardiology/utils';
import './Score.scss';

const getProbabilityDescription = (scoreToDisplay: number) => {
    if (scoreToDisplay >= 85) {
        return (
            <>
                <b>Very High</b> pre-test probability of coronary artery disease.
            </>
        );
    }

    if (scoreToDisplay >= 50) {
        return (
            <>
                <b>High</b> pre-test probability of coronary artery disease.
            </>
        );
    }

    if (scoreToDisplay >= 15) {
        return (
            <>
                <b>Intermediate</b> pre-test probability of coronary artery disease.
            </>
        );
    }

    return (
        <>
            <b>Low</b> pre-test probability of coronary artery disease.
        </>
    );
};

const isForm1586 = window.location.pathname.replace(/\/$/, '') === '/forms/1762';

const Score = ({ score }: { score: number | string; }) => {
    const scoreToDisplay = Math.max(Math.min(parseFloat(score + '') || 0, 100), 0);

    return (
        <div className="scoreWidget">
            <div className="scoreWidget_content">
                <div className="scoreWidget_content_scoreTitle">
                    Probability of Coronary Artery Disease:
                </div>

                <div className="scoreWidget_content_scoreSection">
                    <div className="scoreWidget_content_scoreSection_left">
                        <div className="scoreWidget_content_scoreSection_left_content">
                            <div className="scoreWidget_content_scoreSection_left_content_top">
                                <div className="scoreWidget_content_scoreSection_left_content_model">
                                    <div className="scoreWidget_content_scoreSection_left_content_score">
                                        {getScoreDisplayValue(scoreToDisplay)}
                                    </div>

                                    <div className="scoreWidget_content_scoreSection_left_content_scoreDescription">
                                        Clinic + CCS Model
                                    </div>
                                </div>

                                {isForm1586 && (
                                    <div className="scoreWidget_content_scoreSection_left_content_aiScore">
                                        <div className="scoreWidget_content_scoreSection_left_content_aiScore_value">
                                            -
                                        </div>

                                        <div className="scoreWidget_content_scoreSection_left_content_aiScore_text">
                                            AI Score
                                            <br/>
                                            (under development)
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="scoreWidget_content_scoreSection_left_content_scoreDescription2">
                                {getProbabilityDescription(scoreToDisplay)}
                            </div>
                        </div>
                    </div>

                    <div className="scoreWidget_content_scoreSection_right">
                        <div className="score-rectangle">
                            <div className="high">
                                High
                            </div>

                            <div className="med">
                                Med
                            </div>

                            <div className="low">
                                Low
                            </div>

                            <div className="zero"/>

                            <div
                                className="yourRisk"
                                style={{
                                    top: `calc(${getScorePosition(scoreToDisplay)}% - 4px)`,
                                }}
                            >
                                <div className="rect"/>
                                ← Your Risk
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Score;